/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerUpdateMutationRequest, OwnersControllerUpdateMutationResponse, OwnersControllerUpdatePathParams, OwnersControllerUpdate400, OwnersControllerUpdate401, OwnersControllerUpdate403, OwnersControllerUpdate404 } from "../../models/ownersController/OwnersControllerUpdate";

function getOwnersControllerUpdateUrl(id: OwnersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/owners/${id}` as const }  
  return res
}

/**
 * @summary Update an owner
 * {@link /api/v1/owners/:id}
 */
export async function ownersControllerUpdate(id: OwnersControllerUpdatePathParams["id"], data?: OwnersControllerUpdateMutationRequest, config: Partial<RequestConfig<OwnersControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<OwnersControllerUpdateMutationResponse, ResponseErrorConfig<OwnersControllerUpdate400 | OwnersControllerUpdate401 | OwnersControllerUpdate403 | OwnersControllerUpdate404>, OwnersControllerUpdateMutationRequest>({ method : "PATCH", url : getOwnersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}